import React from 'react';
import { ApolloConsumer } from 'react-apollo';
import RequestProvider from '../../RequestProvider';
import withPublicLink from '../../WithPublicLink';
import { withFlagsConsumer } from '../../FeatureFlags';

import CollaborationProviderComponent from '../components/CollaborationProvider';
import {
  getUsersByName,
  getTeamsByName,
  getResourceRoles,
  upsertRoleAssignments,
  deleteRoleAssignments,
  getRoleAssignments,
  updateRoleAssignments } from
'../api';











function CollaborationProvider(props) {
  return (
    <ApolloConsumer>
      {(apiClient) =>
      <RequestProvider
        requests={{
          getUsersByName: getUsersByName(),
          getTeamsByName: getTeamsByName(),
          updateRoleAssignments: updateRoleAssignments(),
          upsertRoleAssignments: upsertRoleAssignments(),
          getResourceRoles: getResourceRoles(),
          deleteRoleAssignments: deleteRoleAssignments(),
          getRoleAssignments: getRoleAssignments()
        }}>

          {(requests) =>
        <CollaborationProviderComponent
          {...props}
          {...requests}
          apiClient={apiClient} />}


        </RequestProvider>}

    </ApolloConsumer>);

}

export default withPublicLink(withFlagsConsumer(CollaborationProvider));